/* Al Ubaid Motors BYD MSRP data. Upload this file to Shopify Assets as aum-byd-msrp-complete.js */
(function(){
  const AUM_ROWS = window.AUM_ROWS = window.AUM_ROWS || [];

  /*
    BYD MSRP rows recorded from the user-provided BYD batches.
    BYD full EV models use EV category duty rule in the Liquid: CD 25%, ST 13%, IT 6%, all remaining 0%, freight JPY 100,000.
    BYD SEALION 6 is not included here because it is Hybrid/PHEV and is kept in the calculator fallback rows.
    Total BYD EV rows: 27.
  */
  (function aumReplaceBydEvMsrpRows(){
    function cleanText(value){ return String(value || "").toUpperCase().replace(/[^A-Z0-9]+/g,""); }
    function isBydSealion6(row){
      const text = cleanText([row && row.make, row && row.model, row && row.name, row && row.variant, row && row.variantLabel, row && row.method, row && row.status].join(" "));
      return text.includes("BYD") && (text.includes("SEALION6") || text.includes("SEALION06"));
    }
    function isBydRowToReplace(row){
      const text = cleanText([row && row.make, row && row.model, row && row.name, row && row.variant, row && row.variantLabel, row && row.method, row && row.status, row && row.row].join(" "));
      if(!text.includes("BYD")) return false;
      if(isBydSealion6(row)) return false;
      return text.includes("ATTO3") || text.includes("DOLPHIN") || text.includes("SEALION7") || text.includes("SEALION07") || text.includes("SEAL");
    }

    const keptRows = AUM_ROWS.filter(function(row){ return !isBydRowToReplace(row); });
    AUM_ROWS.length = 0;
    keptRows.forEach(function(row){ AUM_ROWS.push(row); });

    const AUM_BYD_PACKED = `07/2025|ATTO 3|BLACK STYLE LIMITED MODEL|ZAA-SC2EXSQ|5|5|SUV|EV|FF|2025|4180000|4455mm × 1875mm × 1615mm|1750
04/2025|ATTO 3|BASE GRADE|ZAA-SC2EXSQ|5|5|SUV|EV|FF|2025|4180000|4455mm × 1875mm × 1615mm|1750
03/2024|ATTO 3|BASE GRADE|ZAA-SC2EXSQ|5|5|SUV|EV|FF|2024|4500000|4455mm × 1875mm × 1615mm|1750
01/2023|ATTO 3|BASE GRADE|ZAA-SC2EXSQ|5|5|SUV|EV|FF|2023|4400000|4455mm × 1875mm × 1615mm|1750
02/2026|DOLPHIN|BASE LINE|ZAA-EM2EXSFS|5|5|HATCHBACK|EV|FF|2026|2992000|4290mm × 1770mm × 1550mm|1520
02/2026|DOLPHIN|LONG RANGE|ZAA-EM2EXSQS|5|5|HATCHBACK|EV|FF|2026|3740000|4290mm × 1770mm × 1550mm|1680
09/2025|DOLPHIN|BASE LINE|ZAA-EM2EXSFS|5|5|HATCHBACK|EV|FF|2025|2992000|4290mm × 1770mm × 1550mm|1520
09/2025|DOLPHIN|LONG RANGE|ZAA-EM2EXSQS|5|5|HATCHBACK|EV|FF|2025|3740000|4290mm × 1770mm × 1550mm|1680
06/2025|DOLPHIN|GRATEFUL PINK LIMITED MODEL|ZAA-EM2EXSF|5|5|HATCHBACK|EV|FF|2025|2992000|4290mm × 1770mm × 1550mm|1520
06/2025|DOLPHIN|LONG RANGE GRATEFUL PINK LIMITED MODEL|ZAA-EM2EXSQ|5|5|HATCHBACK|EV|FF|2025|3740000|4290mm × 1770mm × 1550mm|1680
04/2025|DOLPHIN|BASE LINE|ZAA-EM2EXSF|5|5|HATCHBACK|EV|FF|2025|2992000|4290mm × 1770mm × 1550mm|1520
04/2025|DOLPHIN|LONG RANGE|ZAA-EM2EXSQ|5|5|HATCHBACK|EV|FF|2025|3740000|4290mm × 1770mm × 1550mm|1680
11/2024|DOLPHIN|BASE LINE LIMITED MODEL|ZAA-EM2EXSF|5|5|HATCHBACK|EV|FF|2024|2992000|4290mm × 1770mm × 1550mm|1520
11/2024|DOLPHIN|LIMITED LIMITED MODEL|ZAA-EM2EXSF|5|5|HATCHBACK|EV|FF|2024|3630000|4290mm × 1770mm × 1550mm|1520
11/2024|DOLPHIN|LONG RANGE LIMITED LIMITED MODEL|ZAA-EM2EXSQ|5|5|HATCHBACK|EV|FF|2024|4070000|4290mm × 1770mm × 1550mm|1680
09/2023|DOLPHIN|BASE GRADE|ZAA-EM2EXSF|5|5|HATCHBACK|EV|FF|2023|3630000|4290mm × 1770mm × 1550mm|1520
09/2023|DOLPHIN|LONG RANGE|ZAA-EM2EXSQ|5|5|HATCHBACK|EV|FF|2023|4070000|4290mm × 1770mm × 1550mm|1680
10/2025|SEAL|BASE GRADE RR|ZAA-EKXYC|4|5|SEDAN|EV|RR|2025|4950000|4800mm × 1875mm × 1460mm|2100
10/2025|SEAL|BASE GRADE AWD|ZAA-EKXYA|4|5|SEDAN|EV|AWD|2025|5720000|4800mm × 1875mm × 1460mm|2210
01/2025|SEAL|EDITION PALE GREEN LIMITED MODEL|ZAA-EKXYC|4|5|SEDAN|EV|RR|2025|5280000|4800mm × 1875mm × 1460mm|2100
01/2025|SEAL|EDITION PALE GREEN AWD LIMITED MODEL|ZAA-EKXYA|4|5|SEDAN|EV|AWD|2025|6050000|4800mm × 1875mm × 1460mm|2210
06/2024|SEAL|BASE GRADE RR|ZAA-EKXYC|4|5|SEDAN|EV|RR|2024|5280000|4800mm × 1875mm × 1460mm|2100
06/2024|SEAL|BASE GRADE AWD|ZAA-EKXYA|4|5|SEDAN|EV|AWD|2024|6050000|4800mm × 1875mm × 1460mm|2210
05/2025|SEALION 7|BASE GRADE RR|ZAA-UKXYTS|5|5|SUV|EV|RR|2025|4950000|4830mm × 1925mm × 1620mm|2230
05/2025|SEALION 7|BASE GRADE AWD|ZAA-UKXYAS|5|5|SUV|EV|AWD|2025|5720000|4830mm × 1925mm × 1620mm|2340
04/2025|SEALION 7|BASE GRADE RR|ZAA-UKXYT|5|5|SUV|EV|RR|2025|4950000|4830mm × 1925mm × 1620mm|2230
04/2025|SEALION 7|BASE GRADE AWD|ZAA-UKXYA|5|5|SUV|EV|AWD|2025|5720000|4830mm × 1925mm × 1620mm|2340`;

    AUM_BYD_PACKED.trim().split(/\n+/).forEach(function(line, index){
      const p = line.split("|");
      const sale = p[0];
      const model = p[1];
      const variant = p[2];
      const chassis = p[3];
      const doors = Number(p[4] || 0);
      const seats = Number(p[5] || 5);
      const type = p[6];
      const fuel = p[7];
      const drive = p[8];
      const year = Number(p[9] || 0);
      const msrp = Number(p[10] || 0);
      const dimensions = p[11];
      const weightKg = Number(p[12] || 0);
      const rowId = "BYD-EV-" + sale.replace(/[^0-9]/g,"") + "-" + model.replace(/[^A-Z0-9]/gi,"-").toUpperCase() + "-" + variant.replace(/[^A-Z0-9]/gi,"-").toUpperCase() + "-" + chassis.replace(/[^A-Z0-9]/g,"") + "-" + index;

      AUM_ROWS.push({
        row: rowId,
        chassis: chassis,
        make: "BYD",
        model: model,
        name: "BYD " + model,
        variant: variant,
        variantLabel: variant + " · " + chassis + " · Sale " + sale,
        type: type,
        fuel: fuel,
        year: year,
        cc: 0,
        doors: doors,
        seats: seats,
        drive: drive,
        dimensions: dimensions,
        weightKg: weightKg,
        cur: "JPY",
        msrp: msrp,
        method: "BYD EV MSRP · Sale " + sale + " · source engine 99999cc recorded as EV",
        status: "BYD full EV MSRP · " + model + " · " + chassis + " · " + sale
      });
    });
  })();
})();
